<template>
	<div class="center center-padding">
		API-version: {{ apiVersion }}
		<hr />
		<Button label="Hämta StartModel" :spinIconLeft="spinners.startModel" iconLeft="button_reload.png"
			@click="getStartModel()" />

		{{ startModel }}
		<hr />
		<Button label="Hämta BaseModel" :spinIconLeft="spinners.baseModel" iconLeft="button_reload.png"
			@click="getBaseModel()" />
		<div v-if="baseModel">
			BaseModel exists
		</div>

		<div class="flexcenter">
			<div v-if="baseModel && baseModel.manufactorList"
				@click="console.log('FP: baseModel.manufactorList: ', baseModel.manufactorList)" class="link badge">
				ManufactorList: {{ baseModel.manufactorList.length }}
			</div>


		</div>

		<div class="flexcenter" style="margin-top:10px;">
			<div v-if="baseModel && baseModel.mcList" @click="console.log('FP: baseModel.mcList: ', baseModel.mcList)"
				class="link badge">
				McList: {{ baseModel.mcList.length }}
			</div>
			<div v-if="baseModel && baseModel.mcList" @click="console.log('FP: baseModel.mcTree: ', baseModel.mcTree)"
				class="link badge">
				McTree: {{ baseModel.mcTree.length }}
			</div>

		</div>
		<div class="flexcenter" style="margin-top:10px;">
			<div v-if="baseModel && baseModel.categoryModel"
				@click="console.log('FP: baseModel.categoryModel: ', baseModel.categoryModel)" class="link badge">
				categoryModel exists
			</div>

			<div v-if="baseModel && baseModel.categoryModel && baseModel.categoryModel.categoryList"
				@click="console.log('FP: baseModel.categoryModel.categoryList ', baseModel.categoryModel.categoryList)"
				class="link badge">
				categoryList {{ baseModel.categoryModel.categoryList.length }}
			</div>

			<div v-if="baseModel && baseModel.categoryModel && baseModel.categoryModel.categoryTree"
				@click="console.log('FP: baseModel.categoryModel.categoryTree ', baseModel.categoryModel.categoryTree)"
				class="link badge">
				categoryTree {{ baseModel.categoryModel.categoryTree.categoryList.length }}
			</div>

			<div v-if="baseModel && baseModel.categoryModel && baseModel.categoryModel.categoryTreeMC"
				@click="console.log('FP: baseModel.categoryModel.categoryTreeMC ', baseModel.categoryModel.categoryTreeMC)"
				class="link badge">
				treeMC {{ baseModel.categoryModel.categoryTreeMC.categoryList.length }}
			</div>

			<div v-if="baseModel && baseModel.categoryModel && baseModel.categoryModel.categoryTreeBike"
				@click="console.log('FP: baseModel.categoryModel.categoryTreeBike ', baseModel.categoryModel.categoryTreeBike)"
				class="link badge">
				treeBike {{ baseModel.categoryModel.categoryTreeBike.categoryList.length }}
			</div>

			<div v-if="baseModel && baseModel.categoryModel && baseModel.categoryModel.categoryTreeMotul"
				@click="console.log('FP: baseModel.categoryModel.categoryTreeMotul ', baseModel.categoryModel.categoryTreeMotul)"
				class="link badge">
				treeMotul {{ baseModel.categoryModel.categoryTreeMotul.categoryList.length }}
			</div>

			<div v-if="baseModel && baseModel.categoryModel && baseModel.categoryModel.bikeTypeList"
				@click="console.log('FP: baseModel.categoryModel.bikeTypeList ', baseModel.categoryModel.bikeTypeList)"
				class="link badge">
				bikeTypeList {{ baseModel.categoryModel.bikeTypeList.length }}
			</div>

		</div>


		<hr />
		<Button label="Hämta UserModel" :spinIconLeft="spinners.userModel" iconLeft="button_reload.png"
			@click="getUserModel()" />
		<div style="max-height:200px;overflow:scroll;">
			{{ userModel }}
		</div>
		<hr />
		<Button label="Hämta status" :spinIconLeft="spinners.status" iconLeft="button_reload.png" @click="getStatus()" />


		<hr />

	</div>
</template>

<script>
import { logMixin } from '../../mixins/logMixin';
import { USER_STORE_ACTION, USER_STORE_GETTER } from '../../store/user-store';
import { STORE_ACTION, STORE_GETTER } from '../../store/store';


export default {
	name: "TestDataModels",
	components: {},
	mixins: [logMixin],
	data() {
		return {
			spinners: { baseModel: false, startModel: false, userModel: false, status: false }

		};
	},
	computed: {
		baseModel() {
			return this.$store.getters[STORE_GETTER.BASE_MODEL]
		},
		startModel() {
			return this.$store.getters[STORE_GETTER.START_MODEL]
		},
		userModel() {
			return this.$store.getters[USER_STORE_GETTER.USER_MODEL]
		},
		apiVersion() {
			return this.$store.state.apiVersion;
		}
	},
	methods: {
		getStartModel() {

			if (this.spinners.startModel) {
				if (!window.confirm("Vill du försöka igen?")) {
					return;
				}

			}

			this.spinners.startModel = true

			this.$store.dispatch({ type: STORE_ACTION.GET_START_MODEL, data: {} }).finally(() => {
				this.spinners.startModel = false
			})

		},
		getBaseModel() {

			if (this.spinners.baseModel) {
				if (!window.confirm("Vill du försöka igen?")) {
					return;
				}
			}

			this.spinners.baseModel = true

			this.$store.dispatch({ type: STORE_ACTION.GET_BASE_MODEL, data: {} }).finally(() => {
				this.spinners.baseModel = false
			})

		},
		getUserModel() {

			if (this.spinners.userModel) {
				if (!window.confirm("Vill du försöka igen?")) {
					return;
				}
			}

			this.spinners.userModel = true

			this.$store.dispatch({ type: USER_STORE_ACTION.GET_USER_MODEL, data: {} }).finally(() => {
				this.spinners.userModel = false
			})

		},
		getStatus() {

			if (this.spinners.status) {
				if (!window.confirm("Vill du försöka igen?")) {
					return;
				}

			}

			this.spinners.status = true

			this.$store.dispatch({ type: STORE_ACTION.GET_STATUS, data: {} }).finally(() => {
				this.spinners.status = false
			})

		},
	}
};
</script>

<style scoped></style>
